import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Circle, Path } from '../IconBase'

const Car = ({ color = 'icon.primary', fill = 'transparent', ...props }) => (
  <IconBase viewBox='0 0 21 15' {...props}>
    <Path
      stroke={color}
      fill={fill}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='m17 5-.494-2.136A2.345 2.345 0 0 0 14.211 1H6.636c-1.088 0-2.034.75-2.282 1.81L3.5 5.5'
    />
    <Path
      fill={fill}
      fillRule='evenodd'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M2.172 13.864h2.11c.776 0 1.405-.63 1.405-1.407v-.937h9.375v.937c0
       .777.63 1.407 1.407 1.407h2.11c.646 0 1.171-.525 1.171-1.172v-4.88A2.812
        2.812 0 0 0 16.937 5H3.813A2.812 2.812 0 0 0 1 7.812v4.88c0 .647.525 1.172 1.172 1.172Z'
      clipRule='evenodd'
    />
    <Circle cx={16} cy={8} r={1} fill={color} />
    <Circle cx={5} cy={8} r={1} fill={color} />
  </IconBase>
)

Car.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  fill: PropTypes.string,
}

export default Car
